<template>
  <div
    :class="[
      'flex flex-col bg-racq-true-white rounded-lg border-solid border-[1.5px] border-racq-pale-blue-border shadow-md',
      { 'hover:shadow-xl active:shadow-none': props.productLinkUrl?.value?.href },
    ]"
    :data-test-id="dataTestId"
  >
    <slot name="topContent"></slot>
    <component :is="dynamicTag" v-bind="bindProps" class="!no-underline group z-10">
      <div class="flex flex-col pl-5 pr-5 pt-4 pb-4 md:pl-6 md:pt-6 md:pr-5 md:pb-5">
        <div class="flex justify-between items-center gap-4">
          <div
            :class="[
              'w-11/12 flex flex-col md:flex-row gap-2 md:gap-6 mb-2',
              { 'items-start md:items-center': alignTitleCenter },
            ]"
          >
            <Image :media="icon" />
            <div class="flex flex-col">
              <RichText
                data-test-id="policyTitle"
                class="text-ellipsis whitespace-nowrap md:whitespace-normal overflow-hidden text-lg-bold md:text-base-bold text-racq-med-grey group-active:text-racq-navy group-active:underline group-active:decoration-[10%]"
                :field="{ value: title }"
              />

              <RichText
                v-if="subTitle && !noDescriptionText"
                data-test-id="policySubText"
                class="text-lg text-racq-med-grey md:text-m !no-underline"
                :field="{ value: subTitle }"
              />
              <RichText
                v-if="description && !noDescriptionText"
                data-test-id="description"
                class="text-sm text-racq-med-grey !no-underline"
                :field="{ value: description }"
              />
              <div
                v-if="renewalText && noDescriptionText"
                data-test-id="renewalText"
                class="flex flex-row gap-2 items-center"
              >
                <div class="rounded-[40px] w-2.5 h-2.5 bg-racq-success-green"></div>
                <RichText class="text-sm text-racq-med-grey" :field="{ value: renewalText }"></RichText>
              </div>
            </div>
          </div>

          <div
            v-if="props.productLinkUrl?.value?.href"
            :class="['mt-3.5 md:mt-0', { 'mt-8 md:-mt-3.5': alignTitleCenter }]"
          >
            <img class="max-w-none" width="19" height="19" :src="iconMap.link" alt="linkUrl" />
          </div>
        </div>

        <div
          v-if="renewalText && !noDescriptionText"
          data-test-id="renewalText"
          class="ml-0 md:ml-16 flex flex-row gap-2 items-center"
        >
          <div class="rounded-[40px] w-2.5 h-2.5 bg-racq-success-green"></div>
          <RichText class="text-sm text-racq-med-grey" :field="{ value: renewalText }"></RichText>
        </div>
        <slot name="bottomInnerContent"></slot>
      </div>
    </component>
    <slot name="bottomOuterContent"></slot>
  </div>
</template>

<script lang="ts" setup>
import { RichText, Image, Field, Link as SitecoreLink } from '@sitecore-jss/sitecore-jss-vue';

import { ImageFieldValue } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';
import { computed } from 'vue';

export interface IProductCard {
  title: string;
  subTitle?: string;
  description?: string;
  icon?: Field<ImageFieldValue>;
  renewalText?: string;
  productLinkUrl?: LinkField;
  noDescriptionText?: boolean;
  alignTitleCenter?: boolean;
  dataTestId?: string;
}
const iconMap = {
  link: require('@/assets/icons/link-icon.svg'),
};
const props = defineProps<IProductCard>();

const dynamicTag = computed(() => (props.productLinkUrl?.value?.href ? SitecoreLink : 'span'));
const bindProps = computed(() => (props.productLinkUrl?.value?.href ? { field: props.productLinkUrl } : {}));
</script>
